<template>
  <div>
    <PageHeader :title="title">
      <div class="flex flex-wrap gap-3">
        <SecondaryButton @click="$emit('info')">
          <span class="font-bold text-xs lg:text-sm xl:text-base">⚙️ Comment configurer les primes ?</span>
        </SecondaryButton>
        <SecondaryButton
          v-if="storeRetributionPaymentMethodEstalyGiftCard(currentStore)"
          @click="openRetributionPaymentMethodModal = true"
        >
          <span class="font-bold text-xs lg:text-sm xl:text-base">🎁 Comment les primes sont versées ?</span>
        </SecondaryButton>
      </div>
    </PageHeader>

    <SearchSelector
      v-if="storeOptions.length > 1"
      class="w-full md:w-96 mb-6"
      id="store"
      label="Magasin"
      name="store"
      required
      v-model="currentStoreId"
      :options="storeOptions"
      :search-keyword-threshold="0"
      search-placeholder="Rechercher un magasin"
    />

    <EstalyGiftCardModal :open="openRetributionPaymentMethodModal" @close="openRetributionPaymentMethodModal = false" />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
import { SearchSelector, PageHeader, SecondaryButton } from "@estaly/ui";
import EstalyGiftCardModal from "@/components/retribution/EstalyGiftCardModal.vue";

export default {
  components: {
    SearchSelector,
    PageHeader,
    SecondaryButton,
    EstalyGiftCardModal,
  },

  data() {
    return {
      openRetributionPaymentMethodModal: false,
    };
  },

  props: {
    title: {
      type: String,
      required: true,
    },
  },

  created() {
    const storeIdFromQuery = this.$route.query.storeId;
    // Convert the string to a number to retrieve the store
    const normalizedStoreId = storeIdFromQuery ? Number(storeIdFromQuery) : null;
    this.currentStoreId = normalizedStoreId || this.selectedStoreId || this.filteredStores[0]?.id;
  },

  computed: {
    ...mapState("store", { stores: "index", currentStore: "currentStore" }),
    ...mapState("retributionConfigurations", ["selectedStoreId"]),
    ...mapGetters("store", ["storeRetributionPaymentMethodEstalyGiftCard", "activeOfflineStores"]),

    currentStoreId: {
      get() {
        return this.selectedStoreId;
      },
      async set(value) {
        if (!value) return;

        this.setSelectedStoreId(value);

        const url = new URL(location);
        url.searchParams.set("storeId", value);
        history.pushState({}, "", url);

        await Promise.all([this.fetch({ id: value }), this.fetchRetributionConfigurations({ perPage: 1000 })]);
      },
    },

    filteredStores() {
      return this.activeOfflineStores;
    },

    storeOptions() {
      return this.filteredStores.map((store) => ({
        label: store.salesChannel,
        value: store.id,
      }));
    },
  },

  methods: {
    ...mapActions("store", ["fetch"]),
    ...mapActions("retributionConfigurations", ["fetchRetributionConfigurations"]),
    ...mapMutations("retributionConfigurations", ["setSelectedStoreId"]),
  },
};
</script>
